// Port of api/fuel/app/classes/filter/search/games/rules/query/families.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'families',
	isIndex: function() { return 'family' }
})
